import {
  GETList, 
  GETDetail,
  PUTWithToken,
  POSTWithToken,
  DELETEWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/warehouse/v1";

export function getWarehouse(values) {
  const url = `${API_URL}/list?includeAll=true`;
  return GETList(url, values);
}

export function getWarehouseAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function createWarehouse(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getWarehouseDetail(id) {
  return GETDetail(API_URL, id);
}

export function editWarehouse(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archiveWarehouse(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchiveWarehouse(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deleteWarehouse(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}